module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Bold.eot?b80b316cd7cf55a59445c12f55d4e117";